import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useSelector } from "react-redux";
import { TbPlus } from "react-icons/tb";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import ButtonDanger from "@areas/shared/components/buttons/ButtonDanger";
import CustomModal from "@areas/shared/components/personal/modals/CustomModal";
import CustomModalDelete from "@areas/shared/components/personal/modals/CustomModalDelete";

import { fetchWrapper } from "@helpers/fetchwrapper";

import Table from "./blocks/Table";
import MainInfoCard from "./blocks/MainInfoCard";
import {
  initialValues,
  validationSchema,
  confirm,
  ModalBodyAdd,
} from "./blocks/ModalAdd";

function Frame(props) {
  const { company: currentCompany } = useSelector((x) => x.auth);
  const [showModal, setShowModal] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [headerModal, setHeaderModal] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [mentorship, setMentorship] = useState([]);

  const loadData = useCallback(
    () => {
      setLoad(true);
      fetchWrapper
        .get(
          `/v1/api/app/getMentorshipsByCompanyId?offset=${
            page * perPage - perPage
          }&limit=${perPage}&idCompany=${currentCompany.IdCompany}`
        )
        .then((res) => {
          setData(res.data);
          setTotal(res.Total);
          setLoad(false);
        });
    },
    [page, perPage, currentCompany]
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  const toggle = useCallback(
    (mentorship) => {
      if (showModal) {
        setShowModal(false);
      } else {
        if (!mentorship) {
          setHeaderModal("Добавление наставника");
        } else {
          setHeaderModal("Редактирование наставника");
        }
        setMentorship(mentorship);
        setShowModal(true);
      }
    },
    [showModal]
  );

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const toggleDelete = (mentorship) => {
    setMentorship(mentorship);
    setShowModalDelete(true);
  };

  const handleDelete = () => {
    if (mentorship) {
      fetchWrapper
        .post(
          `/v1/personal/deleteMentorship?idMentorship=${mentorship.Id}`,
          null,
          false
        )
        .then(() => {
          setShowModalDelete(false);
          loadData(currentCompany.IdCompany);
        });
    }
  };

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <MainInfoCard currentCompany={currentCompany} />
        <Card>
          <CardBody>
            <div>
           <p> Следующий блок заполняется, если Вы:</p>
<ul className="list-unstyled" style={{ paddingLeft: "20px" }}> 
     <li>- планируете взаимодействовать со школами по профориентационным вопросам;</li>
     <li>- хотите рассказать о профессионалах Вашего предприятия, </li>
     <li>- готовы направлять сотрудников предприятия на профориентационные уроки для рассказа о профессии и/или о Вашем предприятии. </li>
     <li>Учителя через платформу смогут писать Вам о согласовании даты и времени встречи. </li></ul>
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Наставники</h5>
              <ButtonDanger onClick={() => toggle()}>
                <TbPlus />
                Добавить наставника
              </ButtonDanger>
            </div>
          </CardHeader>
          <CardBody>
            <Table
              load={load}
              data={data}
              total={total}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              toggleModal={toggle}
              toggleModalDelete={toggleDelete}
            />
          </CardBody>
        </Card>
        <CustomModal
          isOpen={showModal}
          toggle={toggle}
          header={headerModal}
          body={(validation) => <ModalBodyAdd validation={validation} />}
          validateYupSchema={validationSchema}
          inititalValues={() => initialValues(mentorship, currentCompany)}
          cancel="Закрыть"
          confirm="Сохранить"
          confirmFunction={(values) => {
            confirm(values, loadData);
          }}
        />
        <CustomModalDelete
          isOpen={showModalDelete}
          onDeleteClick={handleDelete}
          onCloseClick={() => setShowModalDelete(false)}
        />
      </Animation>
    </div>
  );
}

export default Frame;
